import React from 'react';
import PropTypes from 'prop-types';
import PaytmIcon from '../../atoms/icons/paytm-new';
import Loader from '../../atoms/icons/loader';
import './micro-payment.m.css';

class LinkAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = { otp: '' };
    this.changeWallet = this.changeWallet.bind(this);
  }
  updateInput(event) {
    const value = event.target.value;
    if (value.match(/^\d{0,6}$/g)) {
      this.setState({ otp: event.target.value });
    }
  }

  changeWallet() {
    global.AccessType && global.AccessType.unsetUser();
    this.props.changeWallet();
  }
  render() {
    return (
      <div data-testid="link-account" id="link-account" styleName="story-subscribe-wrap">
        <div styleName="story-subscribe">
          <div styleName="align">
            <h3 styleName="subscribe-headline">Link your Paytm wallet</h3>
            <p styleName="subscribe-summary">
              OTP has been sent to your registered mobile number. Please enter the OTP to link your
              Paytm wallet.
            </p>
            <div styleName="subscribe-buttons update-mobile-input-group link-account">
              <span styleName="input-icon">
                <PaytmIcon />
              </span>
              <input
                type="text"
                placeholder="Enter OTP"
                value={this.state.otp}
                onChange={this.updateInput.bind(this)}
              />
              <button
                disabled={this.props.isLoading}
                onClick={this.props.payNow.bind(this, this.state.otp)}
                styleName="paywall-button"
              >
                {this.props.isLoading ? <Loader /> : 'Link Account'}
              </button>
            </div>
            {this.props.invalidOtp && (
              <span styleName="error">
                {' '}
                The OTP you have entered is incorrect. Please try again.{' '}
              </span>
            )}
            <span styleName="paywall-footer">
              Change Wallet?{' '}
              <a onClick={this.changeWallet} styleName="paywall-footer-link">
                Click here
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

LinkAccount.propTypes = {
  payNow: PropTypes.func.isRequired,
  changeWallet: PropTypes.func.isRequired,
  invalidOtp: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default LinkAccount;
